import React from "react";

export const UiBlueBox = (props) => {
    return (
        <>
            <div className="sb-blue-box-wrapper">
               {props.children}
            </div>
        </>
    )
}